module.exports = __webpack_public_path__ + "img/Cross.866f2f1f.svg";